import { useSetConfirm } from "@/shared/atoms/useConfirm";
import { useSetPosOrderTable } from "@/shared/atoms/usePosOrderTable";
import { useSetPosOrderSessionData } from "@/shared/atoms/usePosOrderTableSessionAtoms";
import { useSetWaiterView } from "@/shared/atoms/useWaiterView";
import { useIsCartEmpty } from "@/shared/hooks/useCartHook";
import useCommon from "@/shared/hooks/useCommon";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import usePosOrderResetHook from "@/shared/hooks/usePosOrderResetHook";
import {
  useHasOrders,
  useSessionId,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import useOrderSessionDeleteMutation from "@/shared/mutations/orderSessions/useOrderSessionDeleteMutation";

const useResetTableHook = () => {
  const sessionId = useSessionId();
  const hasOrders = useHasOrders();
  const destroy = useOrderSessionDeleteMutation();
  const t = useCommon();
  const reset = usePosOrderResetHook();
  const setTable = useSetPosOrderTable();
  const confirm = useSetConfirm();
  const isCartEmpty = useIsCartEmpty();
  const setPosOrderSessionData = useSetPosOrderSessionData();
  const isWaiter = useIsWaiter();
  const setWaiterView = useSetWaiterView();

  const destroySession = () => {
    const afterDestroy = () => {
      reset();
      if (isWaiter) {
        setWaiterView("tables");
      }
    };

    if (!sessionId) {
      afterDestroy();
      return;
    }

    destroy.mutateAsync([sessionId]).then(afterDestroy);
  };

  const resetTable = () => {
    if (!hasOrders) {
      if (isCartEmpty) {
        destroySession();
      } else {
        confirm({
          message: t("confirmationMessage"),
          cb: () => destroySession(),
        });
      }
    } else {
      setTable(null);
      setPosOrderSessionData(null);
    }
  };

  return { resetTable, destroySession, destroy };
};

export default useResetTableHook;
